const userPortList = {
  'getTeacherList': '/admin/a8/teacher_list/',
  postInfo: '/act3/post_info/'
}

const videoCourseList = {
  getCourseList: '/a8/course/index/',
  getMoreCourseList: '/a8/course/set/list/',
  getCourseHourList: '/a8/course/set/info/',
}

const messageList = {
  getLabelList: '/a8/information/label_list/',
  getMessageList: '/a8/information/list/'
}

export { userPortList, videoCourseList, messageList }



// WEBPACK FOOTER //
// ./src/api/port.js